import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
export default class PollOption extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "option", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "hasVoted", false);
    _defineProperty(this, "totalVotes", 0);
    _defineProperty(this, "votes", 0);
    _defineProperty(this, "voted", false);
    _defineProperty(this, "poll", void 0);
    _defineProperty(this, "canSeeVoteCount", false);
    _defineProperty(this, "answer", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.option = this.attrs.option;
    this.name = this.attrs.name;
    this.state = this.attrs.state;
    this.poll = this.state.poll;

    // JRH fork fix: upstream tested `typeof this.votes === 'number'` here,
    // but this.votes is still its class-field default of 0 at oninit - the
    // option's real count is not read until view(). typeof 0 is always
    // 'number', so canSeeVoteCount was unconditionally true for everyone.
    //
    // The upstream comment claimed "API always returns the field", which is
    // untrue when hide_votes is set: voteCount is then omitted for anyone
    // without the seeVoteCount permission, so view() assigned undefined and
    // the tooltip rendered "NaN votes" (and a NaN percent) to ordinary
    // members. Our club polls run hide_votes on purpose, so every member hit
    // it. Computed in view() instead, from the value actually read.
    this.answer = this.option.answer();
  }
  percent() {
    return this.totalVotes > 0 ? Math.round(this.votes / this.totalVotes * 100) : 0;
  }
  view() {
    var _this$poll$myVotes, _this$option$imageSrc;
    // following values can be changed by ui interactions, so we need to update them on every render
    this.hasVoted = this.state.hasVoted();
    this.totalVotes = this.state.overallVoteCount();
    this.votes = this.option.voteCount();
    // Derived here, where the real value is known. Absent means the viewer is
    // not permitted to see counts, not that the count is zero.
    this.canSeeVoteCount = typeof this.votes === 'number';
    this.voted = this.state.hasVotedFor(this.option);
    const isDisabled = this.state.loadingOptions || this.hasVoted && !this.poll.canChangeVote();
    const width = this.canSeeVoteCount ? this.percent() : Number(this.voted) / (((_this$poll$myVotes = this.poll.myVotes()) == null ? void 0 : _this$poll$myVotes.length) || 1) * 100;
    const onBarClick = e => {
      if (isDisabled || !this.state.showCheckMarks) return;
      e.preventDefault();
      this.state.changeVote(this.option, e);
    };

    // JRH fork: on ranked polls a selected option shows its 1-based
    // position instead of a checkmark, so the voter can see the ranking
    // they are assembling. --ranked also switches off the blend mode
    // upstream applies to .PollAnswer-checkbox (see forum.less) - that
    // blend erases a filled light chip against the coloured bar.
    const rank = this.poll.ranked() && this.voted ? this.state.rankOf(this.option) : null;
    const bar = m("div", {
      className: "PollBar",
      "data-selected": !!this.voted,
      style: "--poll-option-width: ".concat(width, "%"),
      onclick: onBarClick
    }, this.state.showCheckMarks && m("div", {
      className: classList('PollAnswer-checkbox', rank && 'PollAnswer-checkbox--ranked')
    }, rank ? m("span", {
      className: "PollAnswer-rank"
    }, rank) : m("span", {
      className: "checkmark"
    })), m("div", {
      className: "PollAnswer-text"
    }, this.optionDisplayItems().toArray()), this.option.imageUrl() ? m("img", {
      className: "PollAnswer-image",
      src: this.option.imageUrl(),
      srcset: (_this$option$imageSrc = this.option.imageSrcset()) != null ? _this$option$imageSrc : undefined,
      alt: this.option.answer(),
      loading: "lazy"
    }) : null);
    return m("div", {
      className: classList('PollOption', this.hasVoted && 'PollVoted', this.option.imageUrl() && 'PollOption-hasImage'),
      "data-id": this.option.id()
    }, this.canSeeVoteCount ? m(Tooltip, {
      text: app.translator.trans('fof-polls.forum.tooltip.votes', {
        count: this.votes
      }),
      onremove: this.hideOptionTooltip
    }, bar) : bar);
  }
  hideOptionTooltip(vnode) {
    vnode.attrs.tooltipVisible = false;

    // @ts-ignore
    vnode.state.updateVisibility();
  }
  optionDisplayItems() {
    const items = new ItemList();
    items.add('answer', m("span", {
      className: "PollAnswer-text-answer",
      id: "".concat(this.name, "-").concat(this.option.id(), "-label")
    }, this.answer));
    this.voted && !this.state.showCheckMarks && items.add('check', m(Icon, {
      name: "fas fa-check-circle",
      className: "PollAnswer-check"
    }));
    this.canSeeVoteCount && items.add('percent', m("span", {
      className: classList('PollPercent', this.percent() !== 100 && 'PollPercent--option')
    }, this.percent(), "%"));
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollOption', PollOption);